/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * API
 * OpenAPI spec version: 1.0.0
 */

export type GetApiDoctorsPortalMessagesPriority =
    (typeof GetApiDoctorsPortalMessagesPriority)[keyof typeof GetApiDoctorsPortalMessagesPriority];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiDoctorsPortalMessagesPriority = {
    INFO: 'INFO',
    IMPORTANT: 'IMPORTANT',
    CRITICAL: 'CRITICAL',
} as const;
